import { render } from "./SearchItemCustomField.vue?vue&type=template&id=2362d83c&scoped=true"
import script from "./SearchItemCustomField.vue?vue&type=script&lang=ts"
export * from "./SearchItemCustomField.vue?vue&type=script&lang=ts"

import "./SearchItemCustomField.vue?vue&type=style&index=0&id=2362d83c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2362d83c"

export default script